import 'css-chunksrc/client/common/resourceAllocationMenu/search/styles.scss';export default {
  "search": "_search_1nt1l_1"
};